/**
 * Indonesian translation for js-year-calendar
 * Kiki Ldc
 * Based on 
 * Indonesian translation for bootstrap-datepicker
 * Kiki Ldc <7x24th@gmail.com>
 */
 
Calendar.locales ['id'] = {
    days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
    daysShort: ["Ming", "Sen", "Sel", "Rab", "kam", "Jum", "Sab"],
    daysMin: ["Mg", "Sn", "Sl", "Rb", "Km", "Jm", "Sb"],
    months: ["Januari", "Februari", "Maret", "April", "Mai", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember" ],
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Agt", "Sep", "Okt", "Nov", "Des"],
    weekShort: 'W',
    weekStart: 1
};